import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {getLabwareDataById} from 'stores/selectors/labwareStateSelectors';
import {getMinTipPositionByLabwareId} from 'stores/business/protocolManagementBusiness';
import {getWellDepth} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';
import {TaskType} from '../../../../../constants/dataEnum';

function PipettingItemMixingPosition({task, onChange, mixingPositionType}) {
  const {mixingPositionAspirate, mixingPositionDispense, labwareID, type} = task || {};

  const dispatch = useDispatch();

  const labware = useSelector(getLabwareDataById(labwareID));

  const labelAspirate = parseMessage('protocolEditor.taskList.pipettingProfile.mixingPositionAspirate');
  const labelDispense = parseMessage('protocolEditor.taskList.pipettingProfile.mixingPositionDispense');
  const labelMixing = parseMessage('protocolEditor.taskList.pipettingProfile.mixingPosition');
  const bothMixingPositionLabel = parseMessage('protocolEditor.taskList.pipettingProfile.mixingPosition.tooltip');

  let label = mixingPositionType === TaskType.ASPIRATE ? labelAspirate : labelDispense;
  let value = mixingPositionType === TaskType.ASPIRATE ? mixingPositionAspirate : mixingPositionDispense;

  if (!mixingPositionType) {
    label = labelMixing;
    value = mixingPositionAspirate === mixingPositionDispense ? mixingPositionAspirate : '';
  }

  const getMinTipPosition = () => dispatch(getMinTipPositionByLabwareId(labwareID, true));

  return (
    <PipettingProfileItemWrapper>
      <div className="pipetting-profile__item__title">
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <li />
          {label}
        </div>
        {!mixingPositionType && <PipettingProfileInputType.InfoTooltip tooltipLabel={bothMixingPositionLabel} />}
      </div>
      <PipettingProfileInputType.NumericTextBox
        value={value}
        minValue={getMinTipPosition()}
        maxValue={getWellDepth(labware)}
        onChange={(newVal) => onChange(newVal, type)}
      />
      <PipettingProfileInputType.Unit.MillimeterAboveBottomWell />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemMixingPosition.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  mixingPositionType: PropTypes.string,
};

PipettingItemMixingPosition.defaultProps = {
  mixingPositionType: TaskType.ASPIRATE,
};

export default PipettingItemMixingPosition;
